<template>

  <div class="dynamic-page">
    <template v-if="header && pageWrapper.header">
      <Header
          :context="header[0]"
      ></Header>
    </template>

    <section v-if="globalMessages && Array.isArray(globalMessages) && globalMessages.length > 0">
      <v-container fluid>
        <v-row>
          <v-col>
            <Messages :messages="globalMessages"></Messages>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="breadcrumbs" v-if="breadcrumbs">
      <v-container class="pa-0">
        <v-row no-gutters>
          <v-col xs="12" sm="12">
            <bread-crumbs :context="breadcrumbs"/>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <template v-if="loaded">
      <template
          v-if="body && Array.isArray(body)">
        <template
            v-for="(oneBody, index2) in body">
          <dynamic-section
              :key="index2"
              :context="oneBody"/>
        </template>
      </template>
      <section id="hmpSearch">
        <v-container class="white">
          <v-row>

            <v-col class="col-12 col-sm-12 col-md-3 side-bar order-first order-md-last">
              <right-menu></right-menu>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-9">

              <router-link @click="goToPage('/resources/herbmedpro/notes-for-advanced-searches/', $event)"
                           to="/resources/herbmedpro/notes-for-advanced-searches/">
                Notes for Advanced Searches
              </router-link>

              <v-card class="mx-auto" outlined>
                <v-container style="display:none">
                  <div>Search by REFERENCES:</div>
                  <v-form v-model="form.valid">

                    <v-row>
                      <v-col md="7">
                        <div style="padding-bottom: 8px;">
                          Search terms
                        </div>
                        <div>
                          <v-row>
                            <v-col md="8">
                              <div class="search-term" v-for="(term, i) in form.terms" :key="i">
                                <v-text-field
                                    outlined dense hide-details="auto"
                                    v-model="form.terms[i]"
                                    label="Enter Search Term"
                                    required
                                ></v-text-field>
                              </div>
                            </v-col>
                            <v-col>
                              <div class="search-term" v-for="(opt, j) in form.options" :key="j">
                                <v-select dense outlined hide-details="auto"
                                          :items="operators" v-model="form.options[j]"/>

                              </div>
                            </v-col>
                            <v-col md="1"></v-col>
                          </v-row>
                        </div>


                      </v-col>
                      <v-col md="5">
                        <v-row>
                          <v-col>
                            <div>Optional delimiters:</div>
                            Herb
                            <v-select dense outlined label="Select" :items="herbs" v-model="form.herb"
                                      item-text="Name" item-value="Id"/>

                            <div>Field To Search:</div>

                            <template fluid>
                              <v-radio-group v-model="form.searchField">
                                <v-radio label="Summary" value="Summary"></v-radio>
                                <v-radio label="Author" value="Author"></v-radio>
                                <v-radio label="References" value="References"></v-radio>
                                <v-radio label="PubMed ID" value="PubMed ID"></v-radio>
                              </v-radio-group>

                            </template>
                            <v-row>
                            </v-row>
                          </v-col>
                        </v-row>

                      </v-col>
                    </v-row>


                    <v-row>
                      <v-col>
                        <v-btn
                            :disabled="!form.valid"
                            color="success"
                            class="mr-4"
                            @click="doSearch">
                          Search
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-form>
                </v-container>

              </v-card>

              <v-card class="mx-auto" outlined>
                <v-container>
                  <div>Search by HERB ACTIONS and/or HEALTH INDICATIONS:</div>
                  <v-form v-model="form.valid">

                    <v-row>


                      <v-col md="12">
                        Health Indication

                        <v-select
                            :multiple="true"
                            label="Health Indication"
                            v-model="selectedOptions"
                            item-text="name"
                            item-value="name"
                            :items="healthIndication"
                            hint="Select on or more."
                            persistent-hint
                        ></v-select>

                      </v-col>

                    </v-row>


                    <v-row>
                      <v-col>
                        <v-btn
                            :disabled="!form.valid"
                            color="success"
                            class="mr-4"
                            @click="doSearch">
                          Search
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-form>
                </v-container>

              </v-card>

              <div>
                Search Result
                <div>
                  Search Terms:
                  <span>green AND tree</span>,
                  produced
                  <span>8</span>
                  Entries.
                </div>
              </div>

            </v-col>
          </v-row>

        </v-container>
      </section>

    </template>
    <template v-else>
      <v-container class="white dashed-section">
        <v-row>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="py-8">
            <v-skeleton-loader
                type="card-avatar, article, actions, divider,  table-heading, list-item-two-line, image, table-tfoot"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </v-container>

    </template>

    <template v-if="footer && pageWrapper.footer">
      <Footer
          :context="footer"
      ></Footer>
    </template>

  </div>

</template>

<script>
import Messages from "@/components/Messages";
import Header from "@/views/template/Header";
import BreadCrumbs from "@/views/template/BreadCrumbs";
import Footer from "@/views/template/Footer";
import DynamicSection from "@/components/DynamicSection";
import globalMixins from "@/mixins/globalMixins";
import debounce from "lodash/debounce";
import RightMenu from "@/views/partials/common/hmpRightMenu.vue";

export default {
  name: 'adv search',

  mixins: [globalMixins],

  components: {
    RightMenu,
    BreadCrumbs,
    DynamicSection,
    Header,
    Footer,
    Messages
  },

  data: () => ({
    globals: {},
    loaded: false,
    herbs: [],
    healthIndication: [],
    operators: ['AND', 'OR', 'ANDNOT'],
    form: {
      herb: '',
      searchField: '',
      terms: {
        '1': '',
        '2': '',
        '3': '',
        '4': '',
        '5': '',
        '6': '',
      },
      options: {
        '1': 'AND',
        '2': 'AND',
        '3': 'AND',
        '4': 'AND',
        '5': 'AND'
      },
      valid: false,
      fields: {},
    },
    selectedOptions: [], // This will store the selected options
    options: [  // Define your options here
      {name: 1, label: 'Option 1'}
      // Add more options as needed
    ],
  }),

  props: {
    defaultGlobals: {
      type: Object
    }
  },

  computed: {
    pageWrapper() {
      return {
        header: (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase())),
        footer: (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase()))
      }
    }
  },

  async created() {
    await this.init();
  },

  mounted: debounce(function () {
    this.$nextTick(async () => {
      await this.hookAllLinks();
    });
  }, 1000),

  updated: debounce(function () {
    this.$nextTick(async () => {
      await this.hookAllLinks();
    });
  }, 1000),

  methods: {

    customLabel(option) {
      return `${option.label} (${option.selected ? 'selected' : 'unselected'})`;
    },

    async init() {
      await this.setGlobalDefaults();
      await this.loadData();
      this.gethealthIndication();
      //await this.getHerbs();
    },

    async loadData() {
      this.resetPage();
      this.loaded = false;

      return this.loadDataInfo('/resources/herbmedpro/advanced-search/')
          .then(async (pageInfo) => {
            this.loaded = true;
            if (pageInfo) {
              this.resetPage();

              this.pageId = pageInfo.id;
              this.rawPageInfo = pageInfo;

              await this.setPageMeta(pageInfo);

              if (pageInfo.sections) {
                this.body = pageInfo.sections;
              }
            }
            this.$forceUpdate();
          }).catch(error => {
            if (error && error.errors && error.errors[2001]) {
              this.$router.push({name: 'error404'});
            } else {
              console.error(error);
            }
          });

    },


    gethealthIndication() {
      let requestOptions = {
        url: '/abcbridgeapi/hmp/healthIssue',
        method: 'get'
      };

      return this.getSendData(requestOptions)
          .then(async response => {
            this.healthIndication = response;
          });
    },


    async getHerbs() {
      let requestOptions = {
        url: '/abcbridgeapi/',
        method: 'post',
        body: {}
      };

      return this.getSendData(requestOptions)
          .then(async response => {
            this.herbs = response.items;
          });
    },

    triggerRerenderMenu(updatedMenu) {
      this.$emit('rerenderMenu', updatedMenu);
    },

    doSearch() {
      // const _self = this;
      // this.$emit('triggerOverlayLoading', true);

      for (let x = 1; x < 7; x++) {
        if (this.form.terms[x]) {
          console.log(this.form.terms[x]);
        }
      }

      let requestOptions = {
        url: '/abcbridgeapi/',
        method: 'post',
        body: {}
      };

      return this.getSendData(requestOptions);
    }
  }
}
</script>

<style>

#hmpSearch div.v-input__slot {
  background: white;
  background-color: white;
}

.mx-auto.v-card {
  background-color: #F9FAFB;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 18%);
  /*padding: 16px;*/
}

.search-term {
  margin-bottom: 10px;
}

.v-select-list {
  max-height: 300px; /* Adjust the max height as needed */
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Set the number of columns here */
  gap: 10px; /* Adjust the gap between columns */
}

</style>
